<!-- Nav Start-->
<header class="agency custom-scroll" [className]="isAbsolutePosition == 'true' ? 'nav-abs' : ''" id="nav-component">
    <div class="container">
        <div class="row">
            <div class="col">
                <nav class="justify-content-between">
                    <div class="logo d-flex align-items-end">
                        <a class="link-sound" [routerLink]="''"><img src="assets/images/logo/logo-header.png"
                                alt="Custom Solutions Logo" width="257" height="144" loading="lazy"></a>
                    </div>
                    <app-menu currentPage={{currentPage}}></app-menu>
                </nav>
            </div>
        </div>
    </div>
</header>
<!-- Nav end-->